/**
 * The tax authority answers in English, and that text is rendered verbatim in the PCN report
 * banner, the summary row and the per-invoice error column — English sentences in an otherwise
 * Hebrew screen.
 *
 * Messages we have seen are mapped to translation keys. Anything unrecognised falls through
 * unchanged, so a new message from the authority stays readable instead of disappearing.
 */

/** Match on wording alone: casing, spacing and trailing punctuation vary between responses. */
const normalize = (message) =>
    String(message ?? '')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/[.,;]+$/, '')
        .toLowerCase();

const MESSAGE_KEYS = {
    'report received successfully. no incorrect invoices':
        'ReportReceivedSuccessNoIncorrectInvoices',
    'report received successfully. report includes incorrect invoices, check report information':
        'ShaamReportIncludesIncorrectInvoices',
};

/**
 * @param {string} message Raw text from the tax authority.
 * @param {(key: string) => string} t i18n translator.
 * @returns {string} Translated text when the message is known, otherwise the original.
 */
export const translateShaamMessage = (message, t) => {
    const raw = String(message ?? '').trim();
    if (!raw) return raw;

    const key = MESSAGE_KEYS[normalize(raw)];
    if (!key || typeof t !== 'function') return raw;

    // i18next echoes the key back when it has no entry for it.
    const translated = t(key);
    return translated && translated !== key ? translated : raw;
};

export default translateShaamMessage;
